<dx-validation-group [formGroup]="form">
  <div class="dx-fieldset">
    <!-- Vehicle ID -->
    <div class="dx-field">
      <div class="dx-field-label">Vehicle ID (Active Vehicles Only) *</div>
      <div class="dx-field-value">
        <dx-select-box
          [dataSource]="helperService.vehicleDso$ | async"
          [displayExpr]="helperService.vehicleDisplayExpression"
          (onValueChanged)="onVehicleChange($event)"
          valueExpr="id"
          placeholder="Select..."
          formControlName="vehicleId">
        </dx-select-box>
      </div>
    </div>

    <div *ngIf="selectedVehicle?.meta">
      <div class="dx-field-hint">
        <b>Last CI Date:</b> {{ selectedVehicle.meta.lastCIDate | date: 'shortDate' }}, <b>Last CI Odometer:</b>
        {{ selectedVehicle.meta.lastCIOdometer }}
      </div>
    </div>

    <!-- Miles -->
    <div class="dx-field">
      <div class="dx-field-label">Miles</div>
      <div class="dx-field-value">
        <dx-number-box placeholder="Enter Miles" formControlName="miles" mode="number" min="0"> </dx-number-box>
      </div>
    </div>

    <!-- Mechanics Shop ID -->
    <div class="dx-field">
      <div class="dx-field-label">Mechanics Shop</div>
      <div class="dx-field-value">
        <dx-select-box
          [dataSource]="helperService.autoRepairShopDso$ | async"
          displayExpr="name"
          valueExpr="id"
          placeholder="Select..."
          (onValueChanged)="onMechanicsShopChange($event)"
          formControlName="mechanicsShopId">
        </dx-select-box>
      </div>
    </div>

    <!-- Date/Time In -->
    <div class="dx-field">
      <div class="dx-field-label">Date/Time In</div>
      <div class="dx-field-value">
        <dx-date-box type="datetime" placeholder="Select Date/Time In" formControlName="dateTimeIn"> </dx-date-box>
      </div>
    </div>

    <!-- Date/Time Out -->
    <div class="dx-field">
      <div class="dx-field-label">Date/Time Out</div>
      <div class="dx-field-value">
        <dx-date-box type="datetime" placeholder="Select Date/Time Out" formControlName="dateTimeOut"> </dx-date-box>
      </div>
    </div>

    <!-- Fleet Manager Assigned ID -->
    <div class="dx-field">
      <div class="dx-field-label">Fleet Manager Assigned</div>
      <div class="dx-field-value">
        <dx-select-box
          [dataSource]="helperService.fleetManagersDso$ | async"
          [displayExpr]="helperService.displayExpr"
          valueExpr="employee_id"
          placeholder="Select..."
          (onValueChanged)="onFleetManagerChange($event)"
          formControlName="fleetManagerAssignedId">
        </dx-select-box>
      </div>
    </div>

    <!-- Mechanic Assigned -->
    <div class="dx-field">
      <div class="dx-field-label">Mechanic Assigned</div>
      <div class="dx-field-value">
        <dx-select-box
          [dataSource]="helperService.fleetMechanicsDso$ | async"
          [displayExpr]="helperService.displayExpr"
          valueExpr="employee_id"
          placeholder="Select..."
          (onValueChanged)="onMechanicAssignedChange($event)"
          formControlName="mechanicAssignedId">
        </dx-select-box>
      </div>
    </div>

    <!-- Invoices Section -->
    <div class="dx-fieldset invoices-frame">
      <button class="add" dx-button type="button" text="Add Invoice" (click)="addInvoice()">+</button>
      <legend>Invoices</legend>
      <div formArrayName="invoices">
        <div *ngFor="let invoice of invoices.controls; let i = index" [formGroupName]="i">
          <!-- Invoice Amount -->
          <div class="dx-field">
            <div class="dx-field-label">Amount</div>
            <div class="dx-field-value">
              <dx-number-box formControlName="amount" (onValueChanged)="onInvoiceChange(i)"> </dx-number-box>
              <button
                *ngIf="invoices.controls.length > 1"
                dx-button
                type="button"
                text="Remove"
                (click)="removeInvoice(i)">
                -
              </button>
            </div>
          </div>

          <!-- Invoice Description -->
          <div class="dx-field">
            <div class="dx-field-label">Description</div>
            <div class="dx-field-value">
              <dx-text-box formControlName="description" (onValueChanged)="onInvoiceChange(i)"> </dx-text-box>
            </div>
          </div>

          <!-- Separator -->
          <hr *ngIf="i < invoices.controls.length - 1" />
        </div>
      </div>
    </div>
  </div>

  <p>
    <dx-validation-summary></dx-validation-summary>
  </p>
</dx-validation-group>
